module.exports = __webpack_public_path__ + "img/2023big9.924921dd.png";